module.exports = __webpack_public_path__ + "static/media/4.94e6f5c8.jpg";